import React from "react";
import "../business-info/business-info.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import { Tooltip } from "@mui/material";
import { styled } from '@mui/material/styles';
import { BorderLeft } from "@mui/icons-material";
import axios from "../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";

class BusinessInformation extends React.Component {
  constructor(props) {
    console.log("this is the business info prop: ", props);
    super(props);

    this.state = {
      LegalName: props?.data ? props.data.legalName : "",
      TaxId: props?.data ? props?.data?.taxIdValue : "",
      PrincipalName: props?.data ? props?.data?.principalNameValue : "",
      alignment: "US",
    };
    this.checkTaxIdExists = this?.checkTaxIdExists?.bind(this);
    this.handleOnClick = this?.handleOnClick?.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this?.props?.data?.userDataFetched && prevProps?.data !== this?.props?.data) {
      this.setState({
        LegalName: this?.props?.data ? this?.props?.data?.legalName : "",
        TaxId: this?.props?.data ? this?.props?.data?.taxIdValue : "",
        PrincipalName: this?.props?.data
          ? this?.props?.data?.principalNameValue
          : "",
      });

      this?.props?.setUserDataFetched(false);
    }
  }

    // Function to check if TaxId already exists
    async checkTaxIdExists(taxId) {
      // try {
      //   const response = await fetch(`Registration/IsTaxIdExists=${taxId}`);
      //   const data = await response.json();
      //   debugger;
      //   return data.exists; // Assuming the API returns { exists: true/false }
      // } catch (error) {
      //   console.error("Error checking TaxId:", error);
      //   return false;
      // }
      // axios
      // .post("Registration/IsTaxIdExists=" + taxId,
      //   {
      //     headers: { "Content-Type": "application/json" },
      //   }
      // )
      axios.get("Registration/IsTaxIdExists=" + taxId)
      .then((res) => {
        if (res?.data?.responseCode == -100) {
          // toast.success("Success", {
          //   position: "top-right",
          //   autoClose: 4000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          // });
          // setRefresh(!refresh);
          const data =  res?.data?.responseCode == -100?false:true
          return data;
          //   debugger;
          //   return data.exists;
        }
        //  else {
        //   toast.error(res?.data?.responseMessage, {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        //   });
        
        // }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // setIsLoading(false);
      });

    }
  
    // Function to handle onClick event
    async handleOnClick() {
      const { LegalName, TaxId, PrincipalName } = this?.state;
  
      // Trim the inputs
      const trimmedLegalName = LegalName?.trim();
      const trimmedTaxId = TaxId?.trim();
      const trimmedPrincipalName = PrincipalName?.trim();
  
      // Check if TaxId exists
      // const taxIdExists = await this.checkTaxIdExists(trimmedTaxId);
      axios.post("Registration/IsTaxIdExists?Taxid=" + TaxId)
    
      .then((res) => {
       
        if (res?.data?.responseCode == -100) {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
      
        }
         else {
          this?.props?.data?.setBusinessInfostates(trimmedLegalName, trimmedTaxId, trimmedPrincipalName);
        
        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  
      // if (taxIdExists) {
      //   alert("TaxId already exists.");
      // } else {
       
      //   this.props.data.setBusinessInfostates(trimmedLegalName, trimmedTaxId, trimmedPrincipalName);
      // }
    }
  async handleName(e) {
    await this?.setState({ LegalName: e });

    e != ""
      ? this?.props?.setLegalNameError("")
      : this?.props?.setLegalNameError("error");
  }
  async handleTaxId(e) {
    await this?.setState({ TaxId: e });
    e != "" ? this?.props?.setTaxIdError("") : this?.props?.setTaxIdError("error");
  }
  async handlePrincipalName(e) {
    await this?.setState({ PrincipalName: e });

    e != ""
      ? this?.props?.setCompanyPrincipalError("")
      : this?.props?.setCompanyPrincipalError("error");
  }
  handleChange = () => {
    if (this?.state?.alignment == "US") {
      this?.setState({ alignment: "international" });
    } else if (this?.state?.alignment == "international") {
      this?.setState({ alignment: "US" });
    }
  };
  render() {

    
    return (
      <>
        <ToastContainer />
        <div className="first-verify__registerationContainer">
          <div className="first-verify__inputContainer">
            <div className="first-verify__toggleOption">
              <ToggleButtonGroup
                color="primary"
                onChange={this?.handleChange}
                value={this?.state?.alignment}
                sx={{
                  height: "50px",
                  width: "180px",
                  border: "1px solid #ccc",
                  backgroundColor: "#F2F4F7",
                }}
              >
                <ToggleButton value="US" className="toggleSwitch">
                  US
                </ToggleButton>
                <ToggleButton value="international">International</ToggleButton>
              </ToggleButtonGroup>
            </div>
            <div>{this?.props?.errorFlag}</div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.businessInfo?.legalName}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6 style={{fontWeight:600}}>Use your business's full legal name.</h6>
                    <h6 style={{fontWeight:600}}>Example:</h6>
                    <h6 style={{fontWeight:600}}> Smith Industries, Inc.</h6>
                  </div>
                }
                arrow
              >
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    height: 50,
                  }}
                  id="outlined-basic"
                  poptext="Only numbers and hyphens are allowed for Tax Id. Please use the format like XXX-XX-XXXX or XX-XXXXXXX"
                  required
                  placeholder={this?.props?.languageContent?.businessInfo?.legalName}
                  value={this?.state?.LegalName}
                  inputProps={{ className: "login-user" }}
                  variant="outlined"
                  onChange={(e) => this?.handleName(e?.target?.value)}
                  error={this?.props?.legalNameErrorFlag}
                />
              </Tooltip>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.businessInfo?.taxId}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
 className="custom-tooltip"
                title={
                  <div >
                    <h6 style={{fontWeight:600}}>Only numbers and hyphens are allowed for Tax Id. Please use the format like XXX-XX-XXXX or XX-XXXXXXX </h6>
                  </div>
                }
                arrow
              >
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    height: 50,
                  }}
                  id="outlined-basic"
                  placeholder={this?.props?.languageContent?.businessInfo?.taxId}
                  inputProps={{ className: "login-user" }}
                  value={this?.state?.TaxId}
                  variant="outlined"
                  onChange={(e) => this?.handleTaxId(e?.target?.value)}
                  error={this?.props?.taxIdErrorFlag}
                />
              </Tooltip>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.businessInfo?.principalName}
                <span className="asterisk-red">*</span>
              </span>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                id="outlined-basic"
                placeholder={
                  this?.props?.languageContent?.businessInfo?.principalName
                }
                inputProps={{ className: "login-user" }}
                value={this?.state?.PrincipalName}
                variant="outlined"
                onChange={(e) => this?.handlePrincipalName(e?.target?.value)}
                error={this?.props?.companyPrincipleErrorFlag}
              />
            </div>
            <div className="formControl-container">
              <Button
                variant="contained"
                className="login-button"
                sx={{ padding: "15px", textTransform: "capitalize" }}
                // onClick={() =>
                //   this.props.data.setBusinessInfostates(
                //     this.state.LegalName.trim(),
                //     this.state.TaxId.trim(),
                //     this.state.PrincipalName.trim()
                //   )
                // }
                onClick={this?.handleOnClick}
              >
                {this?.props?.languageContent?.businessInfo?.next}
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default BusinessInformation;